// extracted by mini-css-extract-plugin
export default {"navbarLogo":"NavbarLogo_navbarLogo__Abq1E"};